<template>
  <div class="container-fluid im-fluid" @click="$root.hideMenu">
    <h2 class="im-title">{{ $t("contact.title") }}</h2>
    <div class="row">
      <div class="col-12 col-sm-12 col-lg-8 col-xl-4 border-right">
        <div class="im-col im-col-1">
          <div class="im-block">
            <StatusMessage ref="statusMessageSuccess"></StatusMessage>

            <div class="mb-3">
              <label for="name">{{ $t("contact.name") }}: *</label>
              <input
                id="name"
                v-model.trim="contactUs_name"
                type="text"
                class="form-control"
                :placeholder="$t('contact.name_placeholder')"
                maxlength="40"
                required
              />
            </div>
            <StatusMessage ref="statusMessageName"></StatusMessage>

            <div class="mb-3">
              <label for="email">{{ $t("contact.email") }}: *</label>
              <input
                id="email"
                v-model.trim="contactUs_email"
                type="email"
                class="form-control"
                placeholder="name@example.com"
                maxlength="60"
                required
              />
            </div>
            <StatusMessage ref="statusMessageEMail"></StatusMessage>

            <div class="mb-3">
              <label for="content">{{ $t("contact.message") }}: *</label>
              <textarea
                id="content"
                v-model.trim="contactUs_message"
                class="form-control"
                rows="5"
                maxlength="500"
                required
              ></textarea>
            </div>
            <StatusMessage ref="statusMessageMessage"></StatusMessage>

            <div class="mb-3">
              <ReCaptcha ref="recaptcha"></ReCaptcha>
            </div>
            <StatusMessage ref="statusMessageRobot"></StatusMessage>

            <button
              type="button"
              class="btn btn-primary btn-block"
              :class="{ disabled: submitDisabled }"
              @click="formSubmit"
            >
              {{ $t("contact.send") }}
            </button>

            <StatusMessage ref="statusMessageSubmit"></StatusMessage>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-12 col-lg-4 col-xl-3 border-right">
        <div class="im-col im-col-2">
          <div class="im-block">
            <p>
              <strong>{{ $t("contact.email") }}:</strong><br />
              <span class="js-sales-email" v-html="$root.contactUsEmail()"></span>
            </p>
            <p>
              <strong>{{ $t("contact.phone") }}:</strong><br />
              <a href="tel:+35982825505">+359 82 82 55 05</a>
            </p>
            <p>
              <strong>{{ $t("contact.address") }}:</strong><br />
              {{ $t("contact.company_name") }}<br />
              {{ $t("contact.company_street") }}<br />
              {{ $t("contact.company_city") }}
            </p>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-12 col-xl-5">
        <div class="im-col im-col-3">
          <div class="im-block">
            <GoogleMap ref="googleMap"></GoogleMap>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import StatusMessage from "../shared/StatusMessage.vue";
  import ReCaptcha from "./ReCaptcha.vue";
  import GoogleMap from "./GoogleMap.vue";

  export default {
    name: "ContactUsSection",
    components: {
      StatusMessage,
      ReCaptcha,
      GoogleMap,
    },
    data() {
      return {
        contactUs_name: "",
        contactUs_email: "",
        contactUs_message: "",

        submitDisabled: false,
      };
    },
    methods: {
      formSend(contactUs_name, contactUs_email, contactUs_message, contactUs_captcha) {
        this.$root.request
          .post("/contactus", {
            contactUs_name: contactUs_name,
            contactUs_email: contactUs_email,
            contactUs_message: contactUs_message,
            contactUs_captcha: contactUs_captcha,
          })
          .catch(this.$root.responseErrorHandler)
          .then(this.$root.responseMiddleware)
          .then((response) => {
            // console.dir(response);

            this.submitDisabled = false;

            if (response.success) {
              this.$root.scrollToTop();
              this.$refs.statusMessageSuccess.displaySuccessMessage("contact_us_sent");
              this.resetForm();
            } else if (response.error && response.error.message) {
              this.$refs.statusMessageSubmit.displayErrorMessage(response.error.message);
            }
          });
      },
      formSubmit() {
        if (this.submitDisabled) {
          return;
        }

        // Name
        if (this.contactUs_name == "") {
          this.$refs.statusMessageName.displayErrorMessage("required", {
            attribute: this.$t("contact.name"),
          });
          return;
        }
        this.$refs.statusMessageName.resetStatusMessage();

        // EMail
        if (this.contactUs_email == "") {
          this.$refs.statusMessageEMail.displayErrorMessage("required", {
            attribute: this.$t("contact.email"),
          });
          return;
        }
        if (!this.$root.isEmailValid(this.contactUs_email)) {
          this.$refs.statusMessageEMail.displayErrorMessage("invalid_email");
          return;
        }
        this.$refs.statusMessageEMail.resetStatusMessage();

        // Message
        if (this.contactUs_message == "") {
          this.$refs.statusMessageMessage.displayErrorMessage("required", {
            attribute: this.$t("contact.message"),
          });
          return;
        }
        this.$refs.statusMessageMessage.resetStatusMessage();

        // ReCaptcha
        if (
          typeof this.$refs.recaptcha.verifyKey !== "string" ||
          this.$refs.recaptcha.verifyKey.length < 200
        ) {
          this.$refs.recaptcha.resetRecaptcha();
          this.$refs.statusMessageRobot.displayErrorMessage("recaptcha");
          return;
        }
        this.$refs.statusMessageRobot.resetStatusMessage();

        this.submitDisabled = true;

        this.formSend(
          this.contactUs_name,
          this.contactUs_email,
          this.contactUs_message,
          this.$refs.recaptcha.verifyKey
        );
      },
      resetForm() {
        this.contactUs_name = "";
        this.contactUs_email = "";
        this.contactUs_message = "";

        this.$refs.recaptcha.resetRecaptcha();
      },
    },
  };
</script>
